import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { categoryMap } from '@/lib/catalog';

interface MovieCardProps {
  movie: Movie;
  compact?: boolean;
}

export default function MovieCard({ movie, compact = false }: MovieCardProps) {
  const category = categoryMap[movie.category];

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
      aria-label={`${movie.title} 影视详情`}
    >
      <div className="relative w-full overflow-hidden rounded-lg bg-background-200">
        <div className="aspect-[2/3] w-full">
          <img
            src={movie.poster}
            alt={`${movie.title} 影视作品封面`}
            title={`${movie.title} - ${category.label} - 黄牛视频`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-950/85 via-primary-950/5 to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-95" />

        <span className="absolute left-2 top-2 rounded-md bg-primary-950/75 px-1.5 py-0.5 font-label text-[10px] font-medium text-background-50">
          {category.label}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-0.5 rounded-md bg-accent-500 px-1.5 py-0.5 font-label text-[10px] font-bold text-accent-950">
          <i className="ri-star-fill text-[9px]" />
          {movie.rating.toFixed(1)}
        </span>

        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-2">
          <span className="font-label text-[10px] text-background-100/90">
            {movie.year} · {movie.region}
          </span>
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-background-50/90 text-primary-800 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
            <i className="ri-play-fill text-sm" />
          </span>
        </div>
      </div>

      <h3
        className={`mt-2.5 truncate font-heading font-bold text-foreground-950 transition-colors group-hover:text-primary-700 ${
          compact ? 'text-sm' : 'text-sm md:text-[15px]'
        }`}
      >
        {movie.title}
      </h3>
      <p className="mt-1 truncate text-xs text-foreground-500">
        {movie.genres.join(' / ')} · {movie.duration}
      </p>
    </Link>
  );
}